import { DUBBING_LANDING_PATH } from "../utils/localizedRoutes";

export type DubbingLanguagePair = {
  sourceCode: string;
  targetCode: string;
  target: string;
  slug: string;
  footerLabel: string;
};

export const DUBBING_LANGUAGE_PAIRS: DubbingLanguagePair[] = [
  {
    sourceCode: "en",
    targetCode: "es",
    target: "Spanish",
    slug: "spanish",
    footerLabel: "English to Spanish",
  },
];

export const DUBBING_PAIR_PATH_PREFIX = `${DUBBING_LANDING_PATH}-english-to-`;

export function buildDubbingPairPath(targetSlug: string): string {
  return `${DUBBING_PAIR_PATH_PREFIX}${targetSlug}`;
}

export function getDubbingPairByPath(pathname: string): DubbingLanguagePair | null {
  if (!pathname.startsWith(DUBBING_PAIR_PATH_PREFIX)) {
    return null;
  }

  const slug = pathname.slice(DUBBING_PAIR_PATH_PREFIX.length);
  return DUBBING_LANGUAGE_PAIRS.find((pair) => pair.slug === slug) || null;
}
